import styled from 'styled-components';
import { breakpoint, font } from 'styles/globals';
import { Theme, getColor } from 'styles/theme';

export const Wrapper = styled.div<{ theme: Theme }>`
  font-family: ${font.graphikCond};
  box-shadow: 4px 4px 20px 0px ${getColor('textPrimary')}0D;
  padding: 24px;
  background-color: ${getColor('surfaceWhite')};
  min-height: 120px;

  .search-button {
    max-width: 71px;
    text-transform: none;

    @media (${breakpoint.mdMin}) {
      max-width: 120px;
    }
  }

  .search-bar {
    display: flex;
    justify-content: center;
    max-height: 37px;
  }
`;

export const PopularSearches = styled.div`
  font-family: ${font.graphikCond};
  margin: 8px 0;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%; /* 21px */
  letter-spacing: 0.5px;

  .popular-search {
    margin: 0 4px;
    text-decoration: underline;
    font-family: ${font.graphikCond};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 21px */
    letter-spacing: 0.5px;
    text-decoration-line: underline;
  }
`;
